module.exports = __webpack_public_path__ + "static/img/yellow.bffe7df.gif";


//////////////////
// WEBPACK FOOTER
// ./static/yellow.gif
// module id = oZ1K
// module chunks = 0